module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8011.4207f86a.png";